import { Link } from "react-router-dom";
import { liveFeed } from "@/mocks/news";

export default function LiveFeed() {
  return (
    <section id="live" aria-label="刚刚发生的爆料" className="w-full scroll-mt-24">
      <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
        <div className="flex items-center justify-between px-4 md:px-6 py-4 border-b border-background-200">
          <h2 className="font-heading font-black text-lg md:text-xl text-foreground-950 flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center">
              <span className="w-2.5 h-2.5 rounded-full bg-primary-500 live-dot"></span>
            </span>
            刚刚发生
          </h2>
          <span className="text-xs text-foreground-500">时间线持续滚动更新</span>
        </div>

        <ol className="relative px-4 md:px-6 py-5">
          <span className="absolute left-[26px] md:left-[38px] top-6 bottom-6 w-px bg-background-300"></span>
          {liveFeed.map((item, index) => (
            <li key={`${item.text}-${index}`} className="relative flex gap-4 md:gap-5 pb-6 last:pb-0">
              <span className="relative z-10 shrink-0 w-5 h-5 mt-0.5 flex items-center justify-center rounded-full bg-background-50">
                <span className={`w-2.5 h-2.5 rounded-full ${index === 0 ? "bg-primary-500 live-dot" : "bg-secondary-400"}`}></span>
              </span>
              <div className="min-w-0 flex flex-col gap-1 pb-1">
                <span className="text-xs text-primary-600 w-fit">{item.time}</span>
                <Link to={`/article/${item.id}`} className="text-sm md:text-base text-foreground-900 leading-snug hover:text-primary-700 transition-colors">
                  {item.text}
                </Link>
              </div>
            </li>
          ))}
        </ol>

        <div className="px-4 md:px-6 py-4 border-t border-background-200 bg-background-100">
          <p className="text-xs text-foreground-500">
            以上为今日部分更新记录。想第一时间收到提醒，可在本页底部订阅快讯通知。
          </p>
        </div>
      </div>
    </section>
  );
}